import TextArea from 'antd/es/input/TextArea'
import R from 'app/assets/R'
import { CODE_REGEX } from 'app/common/constants'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { useTranslation } from 'react-i18next'

export const HookFormCommon = () => {
  const { t } = useTranslation()

  return (
    <BaseSpace size={5}>
      <BaseSpace size={5}>
        <BaseForm.Item
          name={'name'}
          required
          label={'Tên tình trạng sinh hoạt'}
          rules={[
            {
              required: true,
              message: t(R.strings.require_field, {
                field: 'Tên tình trạng sinh hoạt',
              }),
            },
          ]}
        >
          <BaseInput placeholder={'Nhập tên tình trạng sinh hoạt'} />
        </BaseForm.Item>
        <BaseForm.Item
          name={'code'}
          required
          label={'Mã tình trạng sinh hoạt'}
          rules={[
            {
              required: true,
              message: t(R.strings.require_field, {
                field: 'Mã tình trạng sinh hoạt',
              }),
            },
            {
                pattern: CODE_REGEX,
                message: "Mã tình trạng sinh hoạt sai định dạng"
              }
          ]}
        >
          <BaseInput placeholder="Nhập mã tình trạng sinh hoạt" />
        </BaseForm.Item>
        <BaseForm.Item name={'description'} label={t(R.strings.description)}>
          <TextArea placeholder="Nhập mô tả" />
        </BaseForm.Item>
      </BaseSpace>
    </BaseSpace>
  )
}
